import { action } from 'satcheljs';
import type { TimeStreamProject } from 'owa-timestream-types';
import type { BoardEditorLoadState } from './schema';

export const openBoardEditorDialog = action(
    'OPEN_BOARD_EDITOR_DIALOG',
    (projectInfo?: Pick<TimeStreamProject, 'projectId' | 'name'>) => ({ projectInfo })
);
export const closeBoardEditorDialog = action('CLOSE_BOARD_EDITOR_DIALOG');

export const setName = action('SET_BOARD_EDITOR_NAME', (newName?: string) => ({ newName }));

export const setLoadState = action(
    'SET_BOARD_EDITOR_LOAD_STATE',
    (loadState: BoardEditorLoadState) => ({ loadState })
);
